import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmationApproveDialog = _resolveComponent("ConfirmationApproveDialog")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_PageHeaderActionItem = _resolveComponent("PageHeaderActionItem")!
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.bienBan)
      ? (_openBlock(), _createBlock(_component_ConfirmationApproveDialog, {
          key: 0,
          "approve-type": "CONFIRM_BBGT",
          "is-display": _ctx.showConfirmDialog,
          "bien-ban-giai-the": _ctx.bienBan,
          onOnClose: _ctx.closeConfirmDialog,
          onOnConfirm: _ctx.handleConfirm
        }, null, 8, ["is-display", "bien-ban-giai-the", "onOnClose", "onOnConfirm"]))
      : _createCommentVNode("", true),
    (_ctx.asMenuItem)
      ? (_openBlock(), _createBlock(_component_PageHeaderActionItem, {
          key: 1,
          variant: "warning",
          disabled: _ctx.computedIsDisabled,
          onClick: _ctx.openConfirmDialog
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_font_awesome_icon, { icon: _ctx.faCheckDouble }, null, 8, ["icon"])
          ]),
          default: _withCtx(() => [
            _createTextVNode(" " + _toDisplayString(_ctx.computedTooltipMessage || 'Kỹ thuật xác nhận'), 1)
          ]),
          _: 1
        }, 8, ["disabled", "onClick"]))
      : (_openBlock(), _createBlock(_component_ButtonCustom, {
          key: 2,
          "button-type": _ctx.ButtonsType.CONFIRM,
          "color-type": _ctx.ButtonTypeColors.WARNING,
          "is-disabled": _ctx.computedIsDisabled,
          "tooltip-message": _ctx.computedTooltipMessage,
          classes: _ctx.classes,
          onClick: _ctx.openConfirmDialog
        }, null, 8, ["button-type", "color-type", "is-disabled", "tooltip-message", "classes", "onClick"]))
  ]))
}